module.exports = __webpack_public_path__ + "media/images/favicon-947f43a95280997330f9c2c5e26a47f6.png";